import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';

// validate settings filter selection group
export function validateSettingFilterSelectionGroup(values: boolean[]): ValidationResult {
  if (!values.includes(true)) {
    return {
      valid: false,
      error: translateFn('Select at least one option.'),
    };
  }

  return { valid: true };
}

// validators for the scope group
export const ruleScopeSpecificValidators = () => [
  RequiredValidator(translateFn('Select at least one group when defining the rule for specific targets.')),
];

// validators for the filtering group
export const ruleFilteringValidators = () => [RequiredValidator(translateFn('Define at least one expression.'))];
